import { render, staticRenderFns } from "./InviteConfirm.vue?vue&type=template&id=7edf2a0f&"
import script from "./InviteConfirm.vue?vue&type=script&lang=ts&"
export * from "./InviteConfirm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports